var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationImportantRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notification_Important_Read_svg__clip0_16519_24420)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notification_Important_Read_svg__clip1_16519_24420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.158 4.08h.01v.01l-.01-.01zM15.462 10.848H9.118v1.016h6.344v-1.016z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.702 19.08H5.238v.008V10.032v1.824l3.312 3.312.96-.664-.96.68-3.312 2.32v1.528l4.208-2.944 1.04-.728 1.568-1.096.792.552a7.278 7.278 0 011.824-1.912h-2.392l-.096-.072-.12-.088-.128.088-.096.072H9.142v1.016h1.232l-.776.536-1.984-1.984V5.784h6.592v3.048h2.784v2.952a7.24 7.24 0 011.872-.256c.424 0 .84.048 1.248.112v-2l-.024-.024h.008l-2.632-1.84-2.776-3.016h-1.528l-.968-.68-.12-.08-.12.088h-.008l-.968.68h-4.4v3.056L3.99 9.608V20.32h7.88a6.342 6.342 0 01-.168-1.24zm6.296-9.392l.736.52-.744.744V9.68l.008.008zM6.574 9.344v2.096l-1.232-1.232 1.232-.864zM18.846 13.392l-4.944 8.672h9.888l-4.944-8.672zm-.344 2.776c0-.096.04-.184.104-.248a.351.351 0 01.248-.104c.096 0 .184.04.248.104a.351.351 0 01.104.248v2.776c0 .096-.04.184-.104.248a.351.351 0 01-.248.104.351.351 0 01-.248-.104.351.351 0 01-.104-.248v-2.776zm.344 5.032a.53.53 0 01-.48-.32.562.562 0 01-.032-.304.48.48 0 01.144-.264.572.572 0 01.264-.144.501.501 0 01.304.032.53.53 0 01.32.48.528.528 0 01-.152.368.528.528 0 01-.368.152z",
    fill: "#4A4A4A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Notification_Important_Read_svg__clip0_16519_24420"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-.01)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Notification_Important_Read_svg__clip1_16519_24420"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.99 4)",
    d: "M0 0h19.8v18.064H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/Notification_Important_Read.3a9239a6.svg";
export { SvgNotificationImportantRead as ReactComponent };